const NBSP = String.fromCharCode(160);

export const normalizeCurrencySpacing = value =>
  String(value ?? '').replace(new RegExp(NBSP, 'g'), ' ');

export const capitalizeFirstLetter = value => {
  const text = String(value ?? '');
  if (!text) return '';

  return `${text.charAt(0).toLocaleUpperCase('pt-BR')}${text.slice(1)}`;
};

export const pluralRules = {
  pt_BR: (choice, choicesLength) => {
    if (choice === 0 && choicesLength >= 3) return 0;
    if (choicesLength <= 2) return choice === 1 ? 0 : 1;

    return choice === 1 ? 1 : 2;
  },
};

export const numberFormats = {
  pt_BR: {
    currency: {
      style: 'currency',
      currency: 'BRL',
    },
    integer: {
      maximumFractionDigits: 0,
    },
  },
  en: {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
    integer: {
      maximumFractionDigits: 0,
    },
  },
};

export const datetimeFormats = {
  pt_BR: {
    short: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
    dayMonth: {
      day: '2-digit',
      month: '2-digit',
    },
    long: {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
    },
    time: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    },
  },
  en: {
    short: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
    dayMonth: {
      day: '2-digit',
      month: '2-digit',
    },
    long: {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
    },
    time: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    },
  },
};
